import { Button } from 'antd';
import useStyles from 'hooks/useStyles';

const FixedButton = ({ ...props }) => {
  const { algorithm } = useStyles();

  return (
    <div
      style={{
        position: 'fixed',
        bottom: props.bottom,
        right: props.right,
        left: props.left,
        zIndex: 100,
      }}
    >
      <Button
        {...props}
        className={!props.disabled && "degrade-button"}
        disabled={false}
        type={props.disabled ? "default" : props.type}
        onClick={(e) => {
          if (!props.disabled && typeof props.onClick === 'function') {
            props.onClick(e);
          }
        }}
        style={{
          ...(props.style || {}),
          ...(props.disabled ? {
            cursor: 'not-allowed',
            backgroundColor: algorithm === 'dark' ? '#262626' : '#F3F3F3',
            color: algorithm === 'dark' ? '#5B5B5B' : '#BDBDBD',
          } : {}),
        }}
      >
        {props.title}
      </Button>
    </div>
  );
};
export default FixedButton;
